import { BodyText, LabelText, TitleText } from '@policygenius/mortar';
import { useField } from 'react-final-form';
import { createUseStyles } from 'react-jss';

import ToggleField from 'components/formInputs/ToggleField';
import FormWrapper from 'components/FormWrapper';
import InputRecommendationCard from 'components/InputRecommendationCard';
import Slider from 'components/Slider';
import { formatDollar } from 'forms/formatters';

import {
  ASK_EXPLAINER_TEXT,
  ASK_HEADER,
  RECOMMENDATION_TEXT,
  RECOMMENDATION_TEXT_BOLD,
  SLIDER_ERROR_MESSAGE,
  SLIDER_HEADER,
} from './constants';
import styles from './styles';
import { BenefitAmountFormProps } from './types';

const useStyles = createUseStyles(styles, { name: 'BenefitAmountForm' });

const BenfitAmountForm: React.FC<BenefitAmountFormProps> = ({
  handleSubmit,
  invalid,
  submitting,
  maximumBenefit,
}) => {
  const sliderValue = useField<number>('benefitAmount');

  const classes = useStyles();

  return (
    <FormWrapper handleSubmit={handleSubmit} invalid={invalid} submitting={submitting}>
      <InputRecommendationCard
        leftPaneCentered
        leftPaneBody={
          <>
            <BodyText size="large">{SLIDER_HEADER}</BodyText>
            <TitleText size="large">{formatDollar(sliderValue.input.value)}</TitleText>
            <Slider
              min={0}
              max={maximumBenefit}
              step={100}
              ariaLabel="benefit amount slider"
              value={sliderValue.input.value}
              // eslint-disable-next-line react/jsx-handler-names
              onChange={sliderValue.input.onChange}
            />
            {!sliderValue.input.value && !!sliderValue.meta.error && (
              <LabelText color="maroon">{SLIDER_ERROR_MESSAGE}</LabelText>
            )}
          </>
        }
        rightPaneBody={
          <BodyText>
            <BodyText as="strong" weight="bold">
              {RECOMMENDATION_TEXT_BOLD}
            </BodyText>{' '}
            {RECOMMENDATION_TEXT}
          </BodyText>
        }
        rightPaneTitle="Our Recommendation"
      />
      <ToggleField groupLabel="Expect income increase" name="expectIncomeIncrease" />
      <div className={classes.askWrapper}>
        <BodyText weight="bold">{ASK_HEADER}</BodyText>
        <BodyText>{ASK_EXPLAINER_TEXT}</BodyText>
      </div>
    </FormWrapper>
  );
};

export default BenfitAmountForm;
